import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "footer-block row justify-center items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "footer-highlight" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createTextVNode(" © 2022 — " + _toDisplayString(_ctx.nowYear) + "   ", 1),
        _cache[0] || (_cache[0] = _createElementVNode("a", {
          class: "s-link text-white",
          href: "https://uriit.ru",
          target: "_blank",
          rel: "noopener noreferrer"
        }, " АУ «Югорский научно-исследовательский институт информационных технологий» ", -1))
      ])
    ])
  ]))
}